<template lang="pug">
  #not-found
    .box
      .columns.is-mobile.is-centered
        WtTitle(h1) PAGE NOT FOUND
      .columns.is-mobile.is-centered
        RouterLink.not-found-link(to="/") Return to home
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "NotFound404",

  components: { WtTitle }
};
</script>

<style lang="sass">
#not-found
  padding-top: 20rem
  background-color: $white-ter
  height: 100vh
  .box
    background-color: $white
    margin-right: 33%
    margin-left: 33%
    width: 33%
  .not-found
    &-link
      color: $black
      &:hover
        color: $grey-dark
</style>
